import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { Element } from "@api/models/Element";

export class CompanyLoadService {
    constructor(
        private objectRepository: ObjectRepository
    ) {

    }

    private readonly COMPANY_SCHEMA_ID = "CompanyStructure";

    async getCompanyByChildId(childId: string): Promise<Element | undefined> {
        if(!childId) {
            return
        }

        const result = await this.objectRepository.find({
            schema: this.COMPANY_SCHEMA_ID,
            objectId: childId,
            include: ['id', 'parentId']
        })

        if(result.parentId) {
            return await this.getCompanyByChildId(result.parentId)
        }
        else {
            return result;
        }
    }
}